module.exports = __webpack_public_path__ + "static/img/pc-web-bg@t.19ee609.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/pc-web-bg@t.jpg
// module id = NbBR
// module chunks = 0